/**
 * Get sibling applications (other applications within the same package) from the current application.
 */

import { createSelector } from 'reselect';

import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';
import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';

export default createSelector(
  [getApplicationSelector],
  (application = null) => application?.siblingApplications || EMPTY_ARRAY,
);
